<template>
    <div class="pageHeader" :class="loginFlag === 1 ? 'pageHeader--full' : 'pageHeader--compact'">
        <div class="jobMain">
            <div class="pageHeader-1">
                <div class="logo">
                    <img v-if="!isRestrictedTestUi" :src="imageSrc" alt="潞安化工招聘">
                    <div v-else class="logo-test-brand" title="招聘测试环境">招聘测试系统</div>
                </div>
            </div>
            <div class="pageHeader-1 pageHeader-1--nav" v-if="loginFlag === 1">
                <div class="pageNav">
                    <ul>
                        <li v-for="item in visibleNav" :key="item.link"><router-link active-class="active-link" :to="item.link">{{ item.title }}<i class="noticeDot" v-if="item.link==='pageNotice' && noticeNum>0"></i></router-link></li>
                    </ul>
                </div>
<!--                <div class="pageLogin" v-if="loginFlag==0" style="padding-top: 30px;">
                    <router-link to="pageIndex"><el-button size="small">登录</el-button></router-link>
                </div>-->
                <div class="pageLogin" v-if="loginFlag==1 && userInfo">
                    <div class="pageLogin-phone">{{ displayPhone }}</div>
                    <div
                        class="pageLogin-avatar-wrap"
                        @mouseenter="openUserCard"
                        @mouseleave="scheduleCloseUserCard"
                    >
                        <el-avatar :size="40" :src="avatarSrc" class="pageLogin-avatar-img"></el-avatar>
                        <transition name="user-card">
                            <div
                                v-show="userCardVisible"
                                class="user-card"
                                @mouseenter="cancelCloseUserCard"
                                @mouseleave="scheduleCloseUserCard"
                            >
                                <div class="user-card-header">
                                    <el-avatar :size="52" :src="avatarSrc"></el-avatar>
                                    <div class="user-card-header-text">
                                        <div class="user-card-name">{{ displayName }}</div>
                                        <div class="user-card-role">{{ roleLabel }}</div>
                                    </div>
                                </div>
                                <div class="user-card-body">
                                    <div class="user-card-row" v-if="userInfo.phone">
                                        <span class="user-card-label">手机号</span>
                                        <span class="user-card-value">{{ userInfo.phone }}</span>
                                    </div>
                                    <div class="user-card-row" v-if="userInfo.realName">
                                        <span class="user-card-label">姓名</span>
                                        <span class="user-card-value">{{ userInfo.realName }}</span>
                                    </div>
                                    <div class="user-card-row" v-if="userInfo.username">
                                        <span class="user-card-label">用户名</span>
                                        <span class="user-card-value">{{ userInfo.username }}</span>
                                    </div>
                                    <div class="user-card-row" v-if="userInfo.email">
                                        <span class="user-card-label">邮箱</span>
                                        <span class="user-card-value">{{ userInfo.email }}</span>
                                    </div>
                                    <div class="user-card-row">
                                        <span class="user-card-label">用户ID</span>
                                        <span class="user-card-value">{{ userInfo.id }}</span>
                                    </div>
                                </div>
                                <button type="button" class="user-card-logout" @click="confirmLoginOut">
                                    <i class="el-icon-switch-button"></i> 退出登录
                                </button>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import logoUrl from '../assets/images/logo.png';
import defaultAvatarUrl from '../assets/images/defaultPhoto.jpeg';
import axios from "axios";
import Cookies from 'js-cookie'
export default {
    name: 'PageHeader',
    inject: {
        recruitmentUi: {
            default: () => ({ verifyMode: 'B', loaded: false }),
        },
    },
    computed: {
        isRestrictedTestUi() {
            return this.recruitmentUi && this.recruitmentUi.verifyMode === 'A'
        },
        /** 登录后展示导航，不含「首页」；模拟练习仅操作人才入口（entranceType=2）可见 */
        visibleNav() {
            if (this.loginFlag !== 1 || !Array.isArray(this.nav)) {
                return [];
            }
            return this.nav.filter((item) => {
                if (item.link === 'pageIndex') {
                    return false;
                }
                if (item.link === 'pageMockExam' && this.userEntranceType !== 2) {
                    return false;
                }
                return true;
            });
        },
        avatarSrc() {
            if (this.userInfo && this.userInfo.avatar) {
                return this.userInfo.avatar;
            }
            return defaultAvatarUrl;
        },
        displayPhone() {
            if (!this.userInfo) {
                return '';
            }
            return this.userInfo.phone || '';
        },
        displayName() {
            if (!this.userInfo) {
                return '用户';
            }
            return this.userInfo.realName || this.userInfo.username || this.userInfo.phone || '用户';
        },
        roleLabel() {
            if (!this.userInfo || this.userInfo.roleId == null) {
                return '';
            }
            if (Number(this.userInfo.roleId) === 2) {
                return '考生';
            }
            return '管理员';
        },
    },
    data() {
        return {
            nav: [],
            imageSrc: logoUrl,
            noticeNum: 2,
            userInfo: null,
            /** 登录入口类别：0优培 1技术 2操作 */
            userEntranceType: null,
            loginFlag: 0,
            userCardVisible: false,
            userCardTimer: null,
        }
    },
    mounted() {
        this.getUserInfo();
    },
    beforeDestroy() {
        this.clearUserCardTimer();
    },
    methods: {
        resolveEntranceType(user) {
            if (!user) {
                return null;
            }
            if (user.entranceType != null && user.entranceType !== '') {
                return Number(user.entranceType);
            }
            if (user.entrance_type != null && user.entrance_type !== '') {
                return Number(user.entrance_type);
            }
            return null;
        },
        getUserInfo: function (){
            // console.log(Cookies.get('reqToKen'))
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/users/info', {
                    headers: {'Authorization': Cookies.get('reqToKen')}
                }).then((res) => {
                    let _d = res.data;
                    if (_d.success) {
                        this.loginFlag = 1;
                        this.userInfo = _d.data;
                        this.userEntranceType = this.resolveEntranceType(_d.data);
                        if(this.userInfo.roleId === 2) {
                            this.nav = [
                              {title: '报名链接', link: 'pageRegLink'},
                              {title: '联系方式', link: 'pageRegNotes'},
                              {title: '我的应聘', link: 'pageMyjob'},
                              {title: '打印准考证', link: 'pagePrint'},
                              {title: '成绩查询', link: 'pageGrade'},
                              {title: '消息通知', link: 'pageNotice'},
                              {title: '模拟练习', link: 'pageMockExam'},
                            ];
                        } else {
                            this.nav = [
                                {title: '数据统计', link: 'pageManagerCount'},
                                {title: '信息审核', link: 'pageManagerJob'},
                                {title: '考试管理', link: 'pageManagerExam'},
                                {title: '成绩维护', link: 'pageManagerGrade'},
                                {title: '系统配置', link: 'pageManagerSet'},
                                {title: '消息通知', link: 'pageNotice'},
                            ];
                        }
                    } else {
                        this.$alert(_d.message );
                    }
                }).catch((error) => {
                    this.$alert( '登录失效，请重新登录！', '登录失效', {
                        confirmButtonText: '确定',
                        callback: () => {
                            if(this.$route.path === '/' || this.$route.path === '/pageIndex') {
                                // window.location.reload();
                            } else {
                                this.$router.push('/');
                            }
                        }
                    });
                    console.log(error)
                    // this.$message.error(error);
                })
            }
        },
        openUserCard() {
            this.clearUserCardTimer();
            this.userCardVisible = true;
        },
        scheduleCloseUserCard() {
            this.clearUserCardTimer();
            this.userCardTimer = setTimeout(() => {
                this.userCardVisible = false;
            }, 220);
        },
        cancelCloseUserCard() {
            this.clearUserCardTimer();
        },
        clearUserCardTimer() {
            if (this.userCardTimer) {
                clearTimeout(this.userCardTimer);
                this.userCardTimer = null;
            }
        },
        confirmLoginOut() {
            this.$confirm('确定要退出当前账号吗？', '退出登录', {
                confirmButtonText: '确定退出',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.loginOut();
            }).catch(() => {});
        },
        loginOut: function () {
            this.userCardVisible = false;
            document.cookie = 'reqToKen' + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
            this.loginFlag = 0;
            this.userInfo = null;
            this.userEntranceType = null;
            this.nav = [];
            if(this.$route.path === '/' || this.$route.path === '/pageIndex') {
                window.location.reload();
            } else {
                this.$router.push('/');
            }
        },
    }
}
</script>

<style scoped>
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .pageHeader{
        position: -webkit-sticky; /* 对于 Safari */
        position: sticky;
        top: 0;
        width: 100%;
        background-color: rgba(255,255,255,0.92); /* 背景颜色 */
        z-index: 1000; /* 确保导航栏在其他内容之上 */
        box-sizing: border-box;
        margin-bottom: 24px;
    }
    .pageHeader--full{
        height: 132px;
        padding-top: 20px;
    }
    .pageHeader--compact{
        height: 96px;
        padding-top: 16px;
        padding-bottom: 8px;
        margin-bottom: 16px;
    }
    .pageHeader-1{height: 80px; overflow: visible;}
    .pageHeader-1--nav{height: 52px;}
    .pageHeader--compact .pageHeader-1{height: 64px;}
    .pageHeader--compact .pageHeader-1--nav{height: 48px;}
    .logo{height: 80px; float: left; min-width: 200px;}
    .pageHeader--compact .logo{height: 64px;}
    .logo-test-brand{
        height: 80px;
        line-height: 80px;
        font-size: 30px;
        font-weight: 700;
        letter-spacing: 0.14em;
        color: #C10007;
        padding-left: 12px;
        border-left: 5px solid #E60012;
        user-select: none;
    }
    .pageHeader--compact .logo-test-brand{
        height: 64px;
        line-height: 64px;
        font-size: 26px;
    }
    .pageNav{float: left; height: 44px; padding-top: 4px;}
    .pageNav ul{padding: 0; margin: 0; list-style: none;}
    .pageNav ul li{line-height: 40px; font-size: 18px; font-weight: 400; float: left; padding-right: 15px;}
    .pageNav ul li a{
        line-height: 1.3;
        color: #323232;
        text-decoration: none;
        display: inline-block;
        padding: 6px 10px 4px;
        position: relative;
        vertical-align: middle;
    }
    .pageNav ul li a.active-link{
        color: #E60012;
        border-bottom: 3px solid #E60012;
        padding-bottom: 2px;
    }
    .noticeDot{width: 4px; height: 4px; position: absolute; right: 5px; top: 8px; background-color: #E60012; border-radius: 2px; display: block;}
    .pageHeader-1--nav .pageLogin{padding-top: 6px;}
    .pageLogin{
        padding-top: 20px;
        float: right;
        display: flex;
        align-items: center;
        gap: 12px;
        height: 40px;
    }
    .pageLogin-phone{
        font-size: 15px;
        color: #364153;
        font-weight: 500;
        line-height: 40px;
        white-space: nowrap;
    }
    .pageLogin-avatar-wrap{
        position: relative;
        flex-shrink: 0;
        cursor: pointer;
    }
    .pageLogin-avatar-img{
        border: 2px solid #FFE2E2;
        box-shadow: 0 2px 8px rgba(230, 0, 18, 0.15);
        transition: transform 0.25s ease, box-shadow 0.25s ease;
    }
    .pageLogin-avatar-wrap:hover .pageLogin-avatar-img{
        transform: scale(1.06);
        box-shadow: 0 4px 14px rgba(230, 0, 18, 0.28);
    }
    .user-card::before{
        content: '';
        position: absolute;
        top: -6px;
        right: 14px;
        width: 12px;
        height: 12px;
        background: #E7000B;
        transform: rotate(45deg);
        border-radius: 2px 0 0 0;
    }
    .user-card{
        position: absolute;
        top: calc(100% + 10px);
        right: 0;
        width: 280px;
        padding: 0;
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 12px 40px rgba(15, 23, 42, 0.14), 0 0 0 1px rgba(0, 0, 0, 0.04);
        overflow: hidden;
        z-index: 1100;
        transform-origin: top right;
    }
    .user-card-header{
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px;
        background: linear-gradient(135deg, #E7000B 0%, #ff4d4f 100%);
        color: #fff;
    }
    .user-card-header-text{flex: 1; min-width: 0;}
    .user-card-name{
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .user-card-role{
        margin-top: 4px;
        font-size: 12px;
        opacity: 0.9;
        display: inline-block;
        padding: 2px 8px;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.2);
    }
    .user-card-body{padding: 12px 16px 8px;}
    .user-card-row{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
        padding: 8px 0;
        border-bottom: 1px solid #F3F4F6;
        font-size: 13px;
        line-height: 20px;
    }
    .user-card-row:last-child{border-bottom: none;}
    .user-card-label{
        color: #99A1AF;
        flex-shrink: 0;
    }
    .user-card-value{
        color: #1E2939;
        text-align: right;
        word-break: break-all;
    }
    .user-card-logout{
        width: 100%;
        margin: 0;
        padding: 12px 16px 14px;
        border: none;
        border-top: 1px solid #F3F4F6;
        background: #FAFAFA;
        color: #6A7282;
        font-size: 14px;
        cursor: pointer;
        transition: background 0.2s ease, color 0.2s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
    }
    .user-card-logout:hover{
        background: #FEF2F2;
        color: #E7000B;
    }
    .user-card-enter-active,
    .user-card-leave-active{
        transition: opacity 0.22s ease, transform 0.22s ease;
    }
    .user-card-enter,
    .user-card-leave-to{
        opacity: 0;
        transform: translateY(-8px) scale(0.96);
    }
</style>
